import React from "react";
import FaqSection from "../components/FaqSection";

const FaqPage = () => {
  return (
    <>
      < FaqSection />
    </>
  );
};

export default FaqPage;
